<template>
  <div class="single-article">
    <h2>Politique de confidentialité - RGPD</h2>
    <br/>
    <legal>
      <template slot-scope="props">
        <div v-html="props.content"></div>
      </template>
    </legal>
    <br/><br/>
  </div>
</template>


<script>
  import { Legal } from 'itrnews-vuejs-api';

  export default {
    name: 'RGPD',
    components: { Legal },
  };
</script>



// WEBPACK FOOTER //
// src/components/RGPD.vue